import type { Translations } from "../types";

const sk: Translations = {
  "meta.title": "Mapa klikov podľa krajín",
  "meta.description":
    "Interaktívna mapa sveta: bezplatné kliky za jednotlivé krajiny a platená podpora cez Stripe, PayPal a Buy Me a Coffee.",

  "app.title": "Mapa klikov podľa krajín",

  "map.intro":
    "Klikni na krajinu na mape a daj jej bezplatný hlas, alebo jej pošli finančnú podporu - oboje sa počíta do kombinovaného rebríčka nižšie. Mapa odráža len podporu v rámci tejto aplikácie, nie skutočné národné bohatstvo alebo HDP.",
  "map.verifying": "Overuje sa …",
  "map.confirmNotRobot": "Skôr než budeš môcť pridať bezplatné kliky, rýchlo potvrď, že nie si robot:",
  "map.tryAgain": "Skúsiť znova",
  "map.registeringClick": "Zaznamenáva sa klik …",
  "map.selectedCountry": "Vybraná krajina: {name}.",
  "map.selectFirstFeedback": "Krajina vybraná. Ak chceš pridať bezplatný klik, najprv nižšie potvrď, že nie si robot.",
  "map.verificationExpired": "Overenie vypršalo - potvrď znova, že nie si robot.",
  "map.slowDown": "Trochu pomalšie - pred ďalším klikom chvíľu počkaj.",
  "map.clickFailed": "Klik sa nepodarilo zaznamenať. Skús to prosím znova.",
  "map.clickErrorGeneric": "Chyba pri zaznamenávaní kliku.",
  "map.leaderboardHeading": "Rebríček krajín",
  "map.emptySelection": "Vyber krajinu na mape, aby si na ňu mohol kliknúť alebo ju podporiť.",
  "map.loadingData": "Načítavajú sa dáta …",

  "worldmap.loadError": "Mapu sa nepodarilo načítať.",
  "worldmap.resetZoom": "Obnoviť priblíženie",
  "worldmap.resetButton": "⤾ Obnoviť",
  "worldmap.loadingMap": "Načítava sa mapa …",
  "worldmap.unknownCountry": "Neznáma",
  "worldmap.ariaClicks": "{name}: {clicks} klikov",
  "worldmap.tooltipClicks": "{clicks} klikov",

  "legend.fewer": "Menej klikov",
  "legend.more": "Viac klikov",

  "list.empty": "Zatiaľ žiadne kliky. Buď prvý!",
  "list.ariaLabel": "Rebríček krajín podľa počtu klikov",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY nie je nastavený - konfiguráciu nájdeš v README.",
  "human.verificationFailedGeneric": "Overenie zlyhalo.",
  "human.networkError":
    "Overenie sa nepodarilo spojiť (chyba siete) - skontroluj VITE_SUPABASE_URL, či je verify-human nasadený, a ALLOWED_ORIGIN; pozri README/NAVODILA.",
  "human.verificationFailedRetry": "Overenie zlyhalo, skús to znova.",

  "provider.stripe": "💳 Karta (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Vybraná krajina",
  "panel.currentlyRanked": "Aktuálne na #{rank}. mieste",
  "panel.shareCopied": "Skopírované ✓",
  "panel.shareShared": "Zdieľané ✓",
  "panel.shareButton": "🔗 Zdieľať",

  "panel.tableClicks": "Kliky",
  "panel.tableFree": "Zadarmo",
  "panel.tablePaid": "Platené",
  "panel.rowAllTime": "Spolu",
  "panel.rowThisYear": "Tento rok",
  "panel.rowThisWeek": "Tento týždeň",
  "panel.rowToday": "Dnes",

  "panel.totalCombined": "Spolu kombinovane:",
  "panel.totalSupport": "Celková podpora:",

  "panel.paymentMethod": "Spôsob platby",
  "panel.noPaymentMethod": "Momentálne nie je k dispozícii žiadny spôsob platby.",
  "panel.supportAmount": "Suma podpory (EUR)",
  "panel.amountRange": "Suma by mala byť medzi {min} a {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Odhadované platené kliky:",
  "panel.ratioInfo":
    "Pomer: {a} = {b} klikov (napr. {c} = {d} klikov). Toto je len odhad pred platbou - konečný počet klikov vždy vypočíta a potvrdí server na základe skutočne potvrdenej platby.",
  "panel.preparing": "Pripravuje sa …",
  "panel.continueWith": "Pokračovať s {provider}",
  "panel.choosePaymentMethod": "Vyber spôsob platby",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME nie je nastavený - konfiguráciu nájdeš v README.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID nie je nastavený - konfiguráciu nájdeš v README.",

  "panel.paypalAmountInfo": "Suma: {amount} (odhadom {clicks} klikov). Dokonči platbu pomocou tlačidla PayPal nižšie.",
  "panel.back": "← Späť",

  "panel.bmcWarningTitle": "⚠️ Skôr než prejdeš na BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Vlož nižšie uvedený kód do poľa správy/poznámky pri platbe — inak nebudeme vedieť, ktorú krajinu podporuješ. Bez kódu nevieme platbu priradiť žiadnej krajine.",
  "panel.copy": "Kopírovať",
  "panel.copied": "Skopírované ✓",
  "panel.suggestedAmount": "Navrhovaná suma:",
  "panel.bmcAmountNote":
    "(odhadom {clicks} klikov). BuyMeCoffee bohužiaľ nepodporuje prenos sumy cez odkaz — zadaj/vyber si ju sám na ich stránke. Skutočný počet klikov sa vždy počíta zo sumy, ktorú na BuyMeCoffee naozaj pošleš, nie z tohto odhadu.",
  "panel.openBmc": "Otvoriť BuyMeCoffee a pokračovať →",
  "panel.waitingProvider": "Čaká sa na potvrdenie platby od poskytovateľa platby …",
  "panel.waitingConfirmation": "Čaká sa na potvrdenie platby …",
  "panel.timedOut":
    "Kontrole vypršal časový limit. Ak si platbu dokončil, mapa sa aktualizuje, keď server dostane potvrdenie - to môže niekedy trvať trochu dlhšie.",
  "panel.checkAgain": "Skontrolovať znova",

  "panel.cancelled": "Platba bola zrušená alebo sa nepodarila. Mapa sa nezmenila.",
  "panel.tryAgain": "Skúsiť znova",

  "panel.confirmed": "✅ Podpora potvrdená!",
  "panel.confirmedBody": "{country} dostala {clicks} platených klikov za {amount}.",

  "panel.errorPreparingSupport": "Chyba pri príprave tvojej podpory.",
  "panel.errorPreparingPayment": "Chyba pri príprave platby.",
  "panel.errorConfirmingPayment": "Chyba pri potvrdzovaní platby.",
  "panel.errorPayingPaypal": "Chyba pri platbe cez PayPal.",

  "share.unranked": "{flag}{country} potrebuje tvoju podporu na mape sveta!\nPomôž jej posunúť sa v rebríčku 👇",
  "share.rank1": "{flag}{country} je aktuálne na #1. mieste!\nPomôž nám zostať na vrchole 👇",
  "share.rankN": "{flag}{country} je aktuálne na #{rank}. mieste!\nPomôž nám dostať sa na #1 👇",

  "language.switcherLabel": "Jazyk",
};

export default sk;
